import React, { useState, useEffect } from "react";
import Select from "react-select";
import axiosConn from "config/axiosConn";
import StateList from "../../helper/State_List.json";
import DistrictList from "../../helper/District_List.json";
import { useNavigate } from "react-router-dom";
import { FormGroup, Form, Input, Row, Col } from "reactstrap";
import { jwtDecode } from "jwt-decode";
import Helper from "../../helper/Common_Helper.js";
import { handleSpeak, handleSpeakWithoutVoice } from "./speechHandlers";
import { handleFocusChange, skipFocusChange } from "./formUtils";
import InputField from "./InputField";
import { useSpeechRecognition } from "react-speech-recognition";
import { Formik, Field, ErrorMessage } from "formik";
import { useRef } from "react";
import { useSelector } from "react-redux";
import Langfield from "../../assets/Json/accountFormLang.json";
import { FastForward } from "phosphor-react";
import * as Yup from "yup";
import InputField12 from "./InputField12";
import VirtualKeyboard from "./VirtualKeyboard/VirtualKeyboard";
import FacultySideBar from "./FacultySideBar";
import { toast } from "react-toastify";
import { changeLang, selectedVoice } from '../../redux/langSlice'
import { useDispatch } from 'react-redux'
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import SpinnerOverlay from "./Spinner";
// import { useSelector } from "react-redux";

function CreateTheme() {
  const navigate = useNavigate();
  const userData = useSelector(state => state.auth.user);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [slectedState, setState] = useState("");
  const [slectedDistrict, setDistrict] = useState("");
  const [role, setRole] = useState("");
  const lang = useSelector((state) => state.lang.selectedLang);
  const voice = useSelector((state) => state.lang.selectedVoice);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [langSelected, setLangSelected] = useState(userData?.lang || 'en-IN');
  const [voiceSelected, setVoiceSelected] = useState(
    voice || "en-IN-NeerjaNeural"
  );
  const translations = Langfield[langSelected];
   const translate = (key) => {
    // Check if translations is defined and is an object
    if (typeof translations !== "object" || translations === null) {
      return key; // Return the key if translations is not available
    }

    // Handle undefined or non-string keys
    if (typeof key !== "string") {
      return key; // Return the value as is if key is not a string
    }

    return translations[key] || key.replace(/_/g, " "); // Use translation or fallback to the key
  };
  const [initialValues, setInitialValues] = useState({
    udise_id: "",
    school_name: "",
    desc: "",
    event_name: "",
    theme_name: "Adopt Healthy Lifestyles",
    sub_themes: [],
    implemnt_mode: "",
    event_type: "",
    number_events: "",
    event_date: "",
    isEventTechIntervention: "",
    haveParticipantPledge: "",
    number_participant_age3to8: "",
    number_participant_age8to11: "",
    number_participant_age11to14: "",
    number_participant_age14to18: "",
    number_participant_age18plus: "",
    state: "",
    district: "",
    city: "",
  });

console.log("844444444444",initialValues);

  const disableRef = useRef(false);
  const nextValueRef = useRef(0);
  const resetRef = useRef(0);
  const nameRef = useRef(null);
  const descRef = useRef(null);
  const lifeThemeRef = useRef(null);
  const subThemeRef = useRef(null);
  const modeRef = useRef(null);
  const eventTypeRef = useRef(null);
  const numberEventsRef = useRef(null);
  const eventDataRef = useRef(null);
  const techInterventionRef = useRef(null);
  const participantPledgeRef = useRef(null);
  const age3to10Ref = useRef(null);
  const age10to15Ref = useRef(null);
  const age15to18Ref = useRef(null);
  const age18to25plusRef = useRef(null);
  const stateRef = useRef(null);
  const districtRef = useRef(null);
  const cityRef = useRef(null);
  const onBtnRef = useRef(null);
  const isKeyBoardInput = useRef(false);
  const {
    browserSupportsSpeechRecognition,
    listening,
    transcript,
    resetTranscript,
  } = useSpeechRecognition();
  const getActiveState = useRef("event_name");
  const [getActive, setActive] = useState("");

  const nextRef = [
    nameRef,
    descRef,
    lifeThemeRef,
    subThemeRef,
    modeRef,
    eventTypeRef,
    numberEventsRef,
    eventDataRef,
    techInterventionRef,
    participantPledgeRef,
    age3to10Ref,
    age10to15Ref,
    age15to18Ref,
    age18to25plusRef,
    stateRef,
    districtRef,
    cityRef,
  ];
  let timer = null;

  // Event creation allows only Adopt Healthy Lifestyles → Plantation Drive,
  // so the one selectable sub-theme is picked for the user. (Kept above the
  // speech-recognition early return so the hook always runs.)
  useEffect(() => {
    const allowed = translate("Plantation Drive");
    if (initialValues.theme_name === "Adopt Healthy Lifestyles" && !(initialValues.sub_themes || []).length) {
      setInitialValues((v) => ({ ...v, sub_themes: [allowed] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues.theme_name, initialValues.sub_themes]);

  useEffect(() => {
    localStorage.removeItem("selectedLanguage");
    localStorage.removeItem("show");
    localStorage.removeItem("hideTranslationButton");
    localStorage.removeItem("key");
    handleFocusChange(nextRef, nextValueRef, resetRef, timer);
  }, []);

  const handleActive = (e) => {
    const elementId = e.target.id;
    setActive(elementId);
  };



  useEffect(() => {
    if (userData) {
      setInitialValues({
        ...initialValues,
        ["udise_id"]: userData?.udise_id,
        ["school_name"]: userData?.school_name,
        ["state"]: userData?.state,
        ["district"]: userData?.district,
      });
      const filteredDistricts = DistrictList.filter(
        (district) => district.state_id === userData?.state_id
      );
      setState(userData?.state);
      setFilterDistrict(filteredDistricts);
      setDistrict(userData?.district);
      setRole(userData?.role);
      setLangSelected(userData?.lang || 'en-IN');
      setVoiceSelected(userData?.voice);
      // getLanguageFunction({ udise_id: userData?.udise_id });
    }
  }, [userData]);

  // const getLanguageFunction = async (data) => {
  //   try {
  //     const response = await axiosConn("post", "get-language", data);
  //     if (response.data.status === "success") {
  //       let lang = response.data.result.lang;
  //       let voice = response.data.result.voice;
  //       setLangSelected(lang);
  //       setVoiceSelected(voice);
  //       dispatch(changeLang(lang));
  //       dispatch(selectedVoice(voice));
  //       localStorage.setItem("langCode", lang);
  //       localStorage.setItem("voice", voice);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleSelectState = (data) => {
    setDistrict("");
    let State = StateList.find((obj) => obj.state_id == data)?.state_name;
    setState(State);
    let filterdistrictList = DistrictList.filter((obj) => obj.state_id == data);
    setFilterDistrict(filterdistrictList);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIsEmpty(false);
    if (name === "event_name" && value.length > 200) {
      toast.warning(translate("You can enter only 200 characters"));
      return;
    }
    setInitialValues({
      ...initialValues,
      [name]: value,
    });
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setIsEmpty(false);
    setInitialValues({
      ...initialValues,
      [name]: value,
    });
  };

  const handleSubThemeChange = (selectedOption) => {
    setInitialValues((prev) => ({
      ...prev,
      sub_themes: selectedOption ? [selectedOption.value] : [],
    }));
  };


  const [isEmpty, setIsEmpty] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const warnings = [
        { condition: !initialValues.event_name, message: translate("Please Enter Event Name") },
        { condition: initialValues.event_name.length > 200, message:translate ("please check Name of The Event (Maximum characters - 200)") },
        { condition: initialValues.desc?.length === 0, message:translate ("Please Enter Description") },
        { condition: initialValues.desc?.trim().split(/\s+/).length > 50, message: translate("Description should not be more than 50 words") },
        { condition: !initialValues.theme_name, message:translate ("Please Select Theme Name" )},
        { condition: initialValues.theme_name !== "Adopt Healthy Lifestyles", message: translate("Only Adopt Healthy Lifestyle can be selected as the Mission LiFE Theme") },
        { condition: (initialValues.sub_themes || [])[0] && initialValues.sub_themes[0] !== translate("Plantation Drive"), message: translate("Only Plantation Drive can be selected as the Mission LiFE Sub-Theme") },
        { condition: !initialValues.sub_themes || initialValues.sub_themes.length === 0, message:translate ("Please Select Sub-Theme Name") },
        { condition: !initialValues.implemnt_mode, message:translate ("Please Select Implementation Mode") },
        { condition: !initialValues.event_type, message:translate ("Please Select Event Type") },
        { condition: !/^\d{1,3}$/.test(initialValues.number_events), message:translate ("Enter a valid number of events") },
        { condition: !/^[a-zA-Z][a-zA-Z0-9]*$/.test(initialValues.cityName), message:translate ("City name must start with a letter and contain only letters and numbers.") },
        { condition: !initialValues.event_date, message:translate ("Please Enter The Date") },
        { condition: !initialValues.sub_themes?.length, message:translate( "Please Select Sub Themes" )},
        { condition: !initialValues.city, message:translate ("Please Enter City") },
        { condition: slectedDistrict === "Select District" || slectedDistrict === "", message:translate ("Please select District." )},
        { condition: slectedState === "Select State" || slectedState === "", message:translate ("Please select State.") }
    ];
    for (const { condition, message } of warnings) {
       toast.dismiss();
        if (condition) { 
            toast.warning(message);
            setIsSubmitting(false);
            setIsEmpty(true);
            return;
        }
    }
    try {
      const postData = {
        ...initialValues,
        district: slectedDistrict,
        state: slectedState,
        lang: langSelected,
        assigned_teacher: [userData?.email],
        auther: userData?.email
      };

      const response = await axiosConn("post", "save-theme", postData, {
        "Content-Type": "application/json",
      }, dispatch);

      if (response.data.status === "success") {
        toast.success(translate("Event Registered Successfully!"));
        navigate("/faculty/eventlist");
      } else {
        toast.error(response.data.message || translate("Failed to register event"));
      }
    } catch (error) {
      console.error("Submission Error Details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      const errorMsg = error.response?.data?.message || translate("An error occurred during submission. Please try again.");
      toast.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }
  
  const subThemes = {
    "Save Energy": [
      {
        value: translate("Energy saving activities like switching off tube-lights, bulbs, electronic gadgets when not in use."),
        label: translate("Energy saving activities like switching off tube-lights, bulbs, electronic gadgets when not in use."),
      },
      {
        value: translate(
          "Knowledge building sessions on renewable sources of energy"
        ),
        label: translate(
          "Knowledge building sessions on renewable sources of energy"
        ),
      },
      {
        value: translate("Competitions (Poster, banner, wall art etc.)"),
        label: translate("Competitions (Poster, banner, wall art etc.)"),
      },
      
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
    "Save Water": [
      {
        value: translate("Tabulate water wastage in school"),
        label: translate("Tabulate water wastage in school"),
      },
      {
        value: translate("Check for leaks in flush systems, faucets, water pipes. Report to the eco-club teacher incharge"),
        label: translate("Check for leaks in flush systems, faucets, water pipes. Report to the eco-club teacher incharge"),
      },
      {
        value: translate("Students along with their teachers can collect water from nearby storage systems/ponds & carry out tests to check water purity"),
        label: translate("Students along with their teachers can collect water from nearby storage systems/ponds & carry out tests to check water purity"),
      },
      {
        value: translate("Water conservation rally along with the community"),
        label: translate("Water conservation rally along with the community"),
      },
      {
        value: translate("Awareness sessions about rainwater harvesting system & its benefits"),
        label: translate("Awareness sessions about rainwater harvesting system & its benefits"),
      },
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
    "Say No to Single Use Plastic": [
      {
        value: translate("Plastic audit of school campus"),
        label: translate("Plastic audit of school campus"),
      },
      {
        value: translate("Awareness campaigns"),
        label: translate("Awareness campaigns"),
      },
      {
        value: translate("Replace plastic water bottles with steel"),
        label: translate("Replace plastic water bottles with steel"),
      },
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
    "Adopt sustainable food systems": [
      {
        value: translate("School Nutrition Garden"),
        label: translate("School Nutrition Garden"),
      },
      {
        value: translate("Classroom Activities"),
        label: translate("Classroom Activities"),
      },
      {
        value: translate("Competitions"),
        label: translate("Competitions"),
      },
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
    "Reduce Waste": [
      { value: translate("Cleanliness Drives"), 
        label: translate("Cleanliness Drives") },
      { value: translate("Awareness on waste segregation/disposal"), 
        label: translate("Awareness on waste segregation/disposal") },
      { value: translate("Installation of 2-bin system in classroom"), 
        label: translate("Installation of 2-bin system in classroom") },
      {
        value: translate("Donation drives to donate old clothes, toys, furniture etc."),
        label: translate("Donation drives to donate old clothes, toys, furniture etc."),
      },
      {
        value: translate("Recycled waste art contest"),
        label: translate("Recycled waste art contest"),
      },
      {
        value: translate("Interaction sessions with the rack pickers/ small junk shop dealers from the nearby locality "),
        label: translate("Interaction sessions with the rack pickers/ small junk shop dealers from the nearby locality "),
      },
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
    "Adopt Healthy Lifestyles": [
      {
        value: translate("Plantation Drive"),
        label: translate("Plantation Drive"),
      },
      {
        value: translate("Nature Walk"),
        label: translate("Nature Walk"),
      },
      {
        value: translate("Awareness session"),
        label: translate("Awareness session"),
      },
      {
        value: translate("Poster Making"),
        label: translate("Poster Making"),
      },
      {
        value: translate("Miyawaki Forest"),
        label: translate("Miyawaki Forest"),
      },
      {
        value: translate("Flora QR codes"),
        label: translate("Flora QR codes"),
      },
      {
        value: translate("Debate"),
        label: translate("Debate"),
      },
      {
        value: translate("Environment Day Celebration"),
        label: translate("Environment Day Celebration"),
      },
      {
        value: translate("Competitions"),
        label: translate("Competitions"),
      },
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
    "Reduce E-Waste": [
      {
        value: translate("E-waste collection drive"),
        label: translate("E-waste collection drive").replace("E-waste", "E-Waste"),
      },
      {
        value: translate("Awareness sessions"),
        label: translate("Awareness sessions"),
      },
      {
        value: translate("Classroom Activities"),
        label: translate("Classroom Activities"),
      },
      {
        value: translate("Competitions"),
        label: translate("Competitions"),
      },
      {
        value: translate("Others"),
        label: translate("Others"),
      },
    ],
  };
   
  const InputFields = [
    {
      name: "event_name",
      label: translate("Name_of_Event"),
      type: "text",
      required: true,
      placeholder: translate("Name_of_Event"),
      innerRef: nameRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Name_of_Event")
        ),
      maxLength: 200, // Add maxLength attribute
    },
    {
      name: "desc",
      label: translate("Breif_Description_Of_Event(Not_More_Than_50_Words)"),
      type: "text",
      required: true,
      placeholder: translate("Breif_Description_Of_Event(Not_More_Than_50_Words)"),
      innerRef: descRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Breif_Description_Of_Event(Not_More_Than_50_Words)")
        ),
    },
    {
      name: "theme_name",
      label: translate("Mission LiFE Theme *"),
      note: translate("(Select only Adopt Healthy Lifestyle)"),
      type: "select",
      required: true,
      selectOptions: [
        { label: translate("Select_life_theme"), value: "", disabled: false },
        { label: translate("Save_Energy"), value: "Save Energy", disabled: true },
        {
          label: translate("Adopt_Healthy_Lifestyles"),
          value: "Adopt Healthy Lifestyles",
          disabled: false
        },
        { label: translate("Reduce_E_Waste"), value: "Reduce E-Waste", disabled: true },
        {
          label: translate("Say_No_to_Single_Use_Plastic"),
          value: "Say No to Single Use Plastic",
          disabled: true
        },
        {
          label: translate("Adopt_sustainable_food_systems"),
          value: "Adopt sustainable food systems",
          disabled: true
        },
        { label: translate("Reduce_Waste"), value: "Reduce Waste", disabled: true },
        { label: translate("Save_Water"), value: "Save Water", disabled: true },
      ],
      innerRef: lifeThemeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Mission LiFE Theme ")
        ),
    },
    {
      name: "sub_themes",
      label: translate("Mission LiFE Sub-Themes *"),
      note: translate("(Select only Plantation Drive)"),
      type: "select",
      required: true,
      selectOptions: [],
      innerRef: subThemeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Mission LiFE Sub-Themes ")
        ),
    },
    {
      name: "implemnt_mode",
      label: translate("Mode_of_Implementation"),
      type: "select",
      required: true,
      selectOptions: [
        { label: translate("Select_Mode"), value: "" },
        { label: translate("Digital"), value: translate("Digital") },
        { label: translate("Physical"), value: translate("Physical") },
      ],
      innerRef: modeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Mode_of_Implementation")
        ),
    },
    {
      name: "event_type",
      label: translate("Type_of_event"),
      type: "select",
      required: true,
      selectOptions: [
        { label: translate("Select_Event_Type"), value: "" },
        { label: translate("Action"), value: translate("Action") },
        { label: translate("Awareness"), value: translate("Awareness") },
        {
          label: translate("Action_&_Awareness_both"),
          value: translate("Action_&_Awareness_both"),
        },
      ],
      innerRef: eventTypeRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Type_of_event")
        ),
    },
    {
      name: "number_events",
      label: translate("Number_of_Events"),
      type: "number",
      required: true,
      innerRef: numberEventsRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Number_of_Events")
        ),
    },
    {
      name: "event_date",
      label: translate("Date_and_Time"),
      type: "date",
      required: true,
      innerRef: eventDataRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("Date_and_Time")
        ),
    },

    {
      name: "state",
      label: translate("State"),
      type: "select",
      selectOptions: StateList.map((obj) => ({
        label: obj.state_name,
        value: obj.state_id,
      })),
      required: true,
      innerRef: stateRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("State")
        ),
    },
    {
      name: "district",
      label: translate("District"),
      type: "select",
      required: true,
      selectOptions: filterDistrict.map((obj) => ({
        label: obj.district_name,
        value: obj.district_id,
      })),
      innerRef: districtRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("District")
        ),
    },
    {
      name: "city",
      label: translate("City"),
      type: "text",
      required: true,
      innerRef: cityRef,
      handleSpeak: (label) =>
        handleSpeak(
          label,
          langSelected,
          voiceSelected,
          getActiveState,
          onBtnRef,
          translate("City")
        ),
    },
  ];

// Event creation is limited to Adopt Healthy Lifestyles → Plantation Drive:
// the other sub-themes stay listed but cannot be selected.
const ALLOWED_SUB_THEME = translate("Plantation Drive");
const filteredOptions = (subThemes[initialValues.theme_name] || []).map((option) => ({
  ...option,
  isDisabled: option.value !== ALLOWED_SUB_THEME,
}));
  const renderInputFields = (fieldConfig, setFieldValue) => {
    return fieldConfig.type === "select" ? (
      <div
        key={fieldConfig.name}
        onFocus={(e) => {
          handleActive(e);
        }}
        className={`col-4 form-group ${getActive === fieldConfig.name ? "active" : null
          } `}
      >
        <label htmlFor={fieldConfig.name}>{fieldConfig.label}
          {fieldConfig.note && (
            <small className="event-theme-note" style={{ fontSize: "0.82em", fontWeight: 600, color: "#b45309", marginLeft: 4, whiteSpace: "normal" }}>
              {` ${fieldConfig.note}`}
            </small>
          )}
          {fieldConfig.required && <span style={{ color: "red" }}>*</span>}


        </label>
        <div className="formgroupIn">
          <Field
            onFocus={(e) => {
              getActiveState.current = fieldConfig.name;
              handleActive(e);
              handleSpeakWithoutVoice(
                fieldConfig.name,
                langSelected,
                voiceSelected,
                getActiveState,
                fieldConfig.label
              );
            }}
            innerRef={fieldConfig.innerRef}
            as="select"
            className="form-control"
            id={fieldConfig.name}
            name={fieldConfig.name}
            value={fieldConfig.value}
            disabled={
              (disableRef.current === true
                ? getActive === fieldConfig.name
                  ? false
                  : false
                : false) || fieldConfig.disabled
            }
            onChange={(e) => {
              setInitialValues({
                ...initialValues,
                [fieldConfig.name]: e.target.value,
              });
              handleFocusChange(nextRef, nextValueRef, resetRef, timer);
            }}
          >
            {fieldConfig.selectOptions.map((option) => (
              <option key={option.value} value={option.value} disabled={option.disabled}>
                {translate(option.label)}
              </option>
            ))}
          </Field>
        </div>
      </div>
    ) : fieldConfig.type === "file" ? (
      <div
        onFocus={(e) => handleActive(e)}
        className={` col-4  form-group ${getActive === "file" ? "active" : null
          }`}
      >
        <label htmlFor="">
          {translate(
            "Bank/Branch_to_affix_rubber_stamp_of_name_and_code_number"
          )}
        </label>

        <div className="formgroupIn">
          <Field
            name="file"
            type="file"
            id="file"
            className="form-control"
            disabled={
              (disableRef.current === true
                ? getActive === fieldConfig.name
                  ? false
                  : true
                : false) || fieldConfig.disabled
            }
          />
        </div>
        <ErrorMessage name="file" component="div" />
      </div>
    ) : fieldConfig.type === "date" ? (
      <div
        ref={fieldConfig.innerRef}
        onFocus={(e) => {
          getActiveState.current = fieldConfig.name;
          handleActive(e);
          handleSpeakWithoutVoice(
            fieldConfig.name,
            langSelected,
            voiceSelected,
            getActiveState,
            fieldConfig.label
          );
        }}
        className={` col-4  form-group ${getActive === fieldConfig.name ? "active" : null
          }`}
      >
        {getActive === fieldConfig.name && (
          <div
            className="skipBtn"
            style={{ cursor: "pointer" }}
            onClick={() => {
              skipFocusChange(
                nextRef,
                nextValueRef,
                handleFocusChange,
                resetRef,
                timer
              );
            }}
          >
            {translate("Skip")} <FastForward size={18} />
          </div>
        )}
        <label htmlFor={fieldConfig.name}>
          {fieldConfig.label}
          {fieldConfig.required && <span style={{ color: "red" }}>*</span>}
        </label>
        <div className="formgroupIn">
          <Input
            name="event_date"
            // min={Helper.currentOrFutureDate()}
            placeholder=""
            type="datetime-local"
            value={initialValues.event_date}
            onKeyDown={(e) => e.preventDefault()}
            onChange={handleInputChange}
          />
          <span className="inptIcn"></span>
        </div>
      </div>
    ) : fieldConfig.type === "text" ? (
      <InputField
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        // saveField={saveField}
        key={fieldConfig.name}
        name={fieldConfig.name}
        value={initialValues[fieldConfig.name]}
        disabled={fieldConfig.disabled}
        label={fieldConfig.label}
        placeholder={fieldConfig.placeholder}
        innerRef={fieldConfig.innerRef}
        handleSpeak={fieldConfig.handleSpeak}
        handleFocusChange={handleFocusChange}
        nextRef={nextRef}
        nextValueRef={nextValueRef}
        resetRef={resetRef}
        timer={timer}
        setFieldValue={setFieldValue}
        getActive={getActive}
        handleActive={handleActive}
        langSelected={langSelected}
        getActiveState={getActiveState}
        onBtnRef={onBtnRef}
        skipFocusChange={skipFocusChange}
        skipBtn={translate("Skip")}
        transcript={transcript}
        listening={listening}
        voiceSelected={voiceSelected}
        resetTranscript={resetTranscript}
        required={fieldConfig.required}
        isKeyBoardInput={isKeyBoardInput}
        handleSpeakWithoutVoice={handleSpeakWithoutVoice}
        disableRef={disableRef}
        requiredBtn={translate("Required")}
      />
    ) : fieldConfig.disabled ? (
      <div
        onFocus={(e) => handleActive(e)}
        className={` col-6  form-group ${getActive === fieldConfig.name ? "active" : null
          }`}
      >
        <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>
        <div className="formgroupIn">
          <Field
            onFocus={(e) => {
              getActiveState.current = fieldConfig.name;
              handleActive(e);
              handleSpeakWithoutVoice(
                fieldConfig.name,
                langSelected,
                voiceSelected,
                getActiveState,
                fieldConfig.label
              );
            }}
            innerRef={fieldConfig.innerRef}
            type={fieldConfig.type}
            className="form-control"
            id={fieldConfig.name}
            name={fieldConfig.name}
            placeholder={fieldConfig.placeholder}
            disabled={fieldConfig.disabled}
          />
          <span className="inptIcn"></span>
        </div>
      </div>
    ) : (
      <InputField
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        // saveField={saveField}
        key={fieldConfig.name}
        name={fieldConfig.name}
        value={initialValues[fieldConfig.name]}
        disabled={fieldConfig.disabled}
        label={fieldConfig.label}
        placeholder={fieldConfig.placeholder}
        innerRef={fieldConfig.innerRef}
        handleSpeak={fieldConfig.handleSpeak}
        handleFocusChange={handleFocusChange}
        nextRef={nextRef}
        nextValueRef={nextValueRef}
        resetRef={resetRef}
        timer={timer}
        type={fieldConfig.type}
        setFieldValue={setFieldValue}
        getActive={getActive}
        handleActive={handleActive}
        langSelected={langSelected}
        getActiveState={getActiveState}
        onBtnRef={onBtnRef}
        skipFocusChange={skipFocusChange}
        skipBtn={translate("Skip")}
        transcript={transcript}
        listening={listening}
        voiceSelected={voiceSelected}
        resetTranscript={resetTranscript}
        required={fieldConfig.required}
        isKeyBoardInput={isKeyBoardInput}
        handleSpeakWithoutVoice={handleSpeakWithoutVoice}
        disableRef={disableRef}
        requiredBtn={translate("Required")}
      />
    );
  };
  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  }
  return (
    <>
      {isSubmitting && <SpinnerOverlay />}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={Yup.object().shape({})}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
        }}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form className="bg-blue-900">
            <section className="scholdashbrdSec">
              <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
                <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
              </div>
              <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
                <FacultySideBar langSelected={langSelected} index={1} role={role} />
              </div>
              <div className="schlDashbrdRgt">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card-user pageContainer">
                      <div class="card-header pgHederSpceArnd ">
                        <div class="d-flex justify-content-between align-items-center">
                          <h5 class="card-title">{translate("Create Event")}</h5>
                        </div>
                      </div>
                      <div className="col-lg-12 text-right relative">
                        <div className="">
                          <VirtualKeyboard lang={langSelected} />
                        </div>
                      </div>
                      <div class="card-body">
                        <Row>
                          <Col md="12">
                            <FormGroup>
                            {InputFields.slice(0, 1).map((fieldConfig) => (
                                <InputField
                                  initialValues={initialValues}
                                  size={12}
                                  setInitialValues={setInitialValues}
                                  // saveField={saveField}
                                  key={fieldConfig.name}
                                  name={fieldConfig.name}
                                  value={initialValues[fieldConfig.name]}
                                  disabled={fieldConfig.disabled}
                                  label={fieldConfig.label}
                                  placeholder={fieldConfig.placeholder}
                                  innerRef={fieldConfig.innerRef}
                                  handleSpeak={fieldConfig.handleSpeak}
                                  handleFocusChange={handleFocusChange}
                                  nextRef={nextRef}
                                  nextValueRef={nextValueRef}
                                  resetRef={resetRef}
                                  timer={timer}
                                  setFieldValue={setFieldValue}
                                  getActive={getActive}
                                  handleActive={handleActive}
                                  langSelected={langSelected}
                                  getActiveState={getActiveState}
                                  onBtnRef={onBtnRef}
                                  skipFocusChange={skipFocusChange}
                                  skipBtn={translate("Skip")}
                                  transcript={transcript}
                                  listening={listening}
                                  voiceSelected={voiceSelected}
                                  resetTranscript={resetTranscript}
                                  required={fieldConfig.required}
                                  isKeyBoardInput={isKeyBoardInput}
                                  handleSpeakWithoutVoice={
                                    handleSpeakWithoutVoice
                                  }
                                  disableRef={disableRef}
                                  requiredBtn={translate("Required")}
                                />
                              ))}
                              {InputFields.slice(1, 2).map((fieldConfig) => (
                                <InputField12
                                  initialValues={initialValues}
                                  setInitialValues={setInitialValues}
                                  // saveField={saveField}
                                  key={fieldConfig.name}
                                  name={fieldConfig.name}
                                  value={initialValues[fieldConfig.name]}
                                  disabled={fieldConfig.disabled}
                                  label={fieldConfig.label}
                                  placeholder={fieldConfig.placeholder}
                                  innerRef={fieldConfig.innerRef}
                                  handleSpeak={fieldConfig.handleSpeak}
                                  handleFocusChange={handleFocusChange}
                                  nextRef={nextRef}
                                  nextValueRef={nextValueRef}
                                  resetRef={resetRef}
                                  timer={timer}
                                  setFieldValue={setFieldValue}
                                  getActive={getActive}
                                  handleActive={handleActive}
                                  langSelected={langSelected}
                                  getActiveState={getActiveState}
                                  onBtnRef={onBtnRef}
                                  skipFocusChange={skipFocusChange}
                                  skipBtn={translate("Skip")}
                                  transcript={transcript}
                                  listening={listening}
                                  voiceSelected={voiceSelected}
                                  resetTranscript={resetTranscript}
                                  required={fieldConfig.required}
                                  isKeyBoardInput={isKeyBoardInput}
                                  handleSpeakWithoutVoice={
                                    handleSpeakWithoutVoice
                                  }
                                  disableRef={disableRef}
                                  requiredBtn={translate("Required")}
                                />
                              ))}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          {InputFields.slice(2, 3).map((fieldConfig) => (
                            <div
                              key={fieldConfig?.name}
                              onFocus={(e) => {
                                handleActive(e);
                              }}
                              className={`col-4 form-group ${getActive === fieldConfig.name
                                ? "active"
                                : null
                                } `}
                            >
                              <label htmlFor={fieldConfig.name}>
                                {fieldConfig.label}
                                {
                                  <span style={{ color: "red" }}>*</span>
                                }
                              </label>
                              <div
                                className="formgroupIn"
                                key={fieldConfig?.name}
                              >
                                <Field
                                  onFocus={(e) => {
                                    getActiveState.current =
                                      fieldConfig.name;
                                    handleActive(e);
                                    handleSpeakWithoutVoice(
                                      fieldConfig.name,
                                      langSelected,
                                      voiceSelected,
                                      getActiveState,
                                      fieldConfig.label
                                    );
                                  }}
                                  innerRef={fieldConfig.innerRef}
                                  as="select"
                                  className="form-control"
                                  id={fieldConfig.name}
                                  name={fieldConfig.name}
                                  value={initialValues.theme_name}
                                  disabled={
                                    (disableRef.current === true
                                      ? getActive === fieldConfig.name
                                        ? false
                                        : false
                                      : false) || fieldConfig.disabled
                                  }
                                  onChange={(e) => {
                                    handleSelectChange(e);
                                    const selectedTheme = e.target.value;
                                        // only Adopt Healthy Lifestyles can be chosen when creating an event
                                        if (selectedTheme !== "Adopt Healthy Lifestyles") return;
                                    let autoSelectedSubTheme = [];

                                    // Auto-select "E-waste awareness and collection drive" when "Reduce E-Waste" is selected
                                    if (selectedTheme === "Reduce E-Waste") {
                                      autoSelectedSubTheme = [translate("E-waste awareness and collection drive")];
                                    }

                                    setInitialValues({
                                      ...initialValues,
                                      theme_name: selectedTheme,
                                      sub_themes: autoSelectedSubTheme
                                    });

                                    // Also update Formik form values for immediate UI update
                                    if (autoSelectedSubTheme.length > 0) {
                                      const selectedOption = filteredOptions.find(
                                        option => option.value === autoSelectedSubTheme[0]
                                      );
                                      if (selectedOption) {
                                        handleSubThemeChange(selectedOption);
                                      }
                                    }

                                    subThemeRef.current.focus();
                                  }}
                                >
                                  {fieldConfig.selectOptions.map(
                                    (option) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                        disabled={option.disabled}
                                      >
                                        {translate(option.label)}
                                      </option>
                                    )
                                  )}
                                </Field>
                              </div>
                            </div>
                          ))}

                          {InputFields.slice(3, 4).map((fieldConfig) => (
                            <div
                              // ref={fieldConfig.innerRef}
                              key={fieldConfig.name}
                              onFocus={(e) => {
                                handleActive(e);
                                handleActive(e);
                              }}
                              className={`col-4 form-group active ${getActive === fieldConfig.name
                                ? "active"
                                : null
                                } `}
                            >
                              <label htmlFor={fieldConfig.name}>
                                {fieldConfig.label}
                                {<span style={{ color: "red" }}>*</span>}
                              </label>
                              <div className="formgroupIn">
                                <Field name={fieldConfig.name}>
                                  {({ field, form }) => {
                                    const handleChange = (selectedOption) => {
                                          if (selectedOption && selectedOption.value !== translate("Plantation Drive")) return;
                                      form.setFieldValue(field.name, selectedOption?.value || "");
                                      handleSubThemeChange(selectedOption); // update local state
                                    };

                                    return (
                                      <Select
                                        {...field}
                                        isSearchable={false}
                                        ref={fieldConfig.innerRef}
                                        isMulti={false}
                                        name="sub_themes"
                                        options={filteredOptions}
                                        className={`${getActive === fieldConfig.name ? "active" : null
                                          } basic-multi-select form-group`}
                                        classNamePrefix="select"
                                        value={filteredOptions.find(
                                          (option) => option.value === (initialValues.sub_themes && initialValues.sub_themes[0])
                                        )}
                                        onChange={handleChange}
                                        onFocus={(e) => {
                                          getActiveState.current = fieldConfig.name;
                                          handleActive(e);
                                          handleSpeakWithoutVoice(
                                            fieldConfig.name,
                                            langSelected,
                                            voiceSelected,
                                            getActiveState,
                                            fieldConfig.label
                                          );
                                        }}
                                        isDisabled={
                                          (disableRef.current === true
                                            ? getActive === fieldConfig.name
                                              ? false
                                              : false
                                            : false) || fieldConfig.disabled
                                        }
                                      />
                                    );
                                  }}
                                </Field>
                              </div>
                            </div>
                          ))}
                          {InputFields.slice(4, 8).map((fieldConfig) =>
                            renderInputFields(fieldConfig, setFieldValue)
                          )}
                        </Row>
                        <Row>
                          {InputFields.slice(8, 9).map((fieldConfig) => (
                            <div
                              key={fieldConfig.name}
                              onFocus={(e) => {
                                handleActive(e);
                              }}
                              className={`col-4 form-group ${getActive === fieldConfig.name
                                ? "active"
                                : null
                                } `}
                            >
                              <label htmlFor={fieldConfig.name}>
                                {fieldConfig.label}
                                {
                                  <span style={{ color: "red" }}>*</span>
                                }

                              </label>
                              <div className="formgroupIn">
                                <Field
                                  onFocus={(e) => {
                                    getActiveState.current =
                                      fieldConfig.name;
                                    handleActive(e);
                                    handleSpeakWithoutVoice(
                                      fieldConfig?.name,
                                      langSelected,
                                      voiceSelected,
                                      getActiveState,
                                      fieldConfig?.label
                                    );
                                  }}
                                  innerRef={fieldConfig.innerRef}
                                  as="select"
                                  className="form-control"
                                  id={fieldConfig.name}
                                  name={fieldConfig.name}
                                  value={fieldConfig.value}
                                  disabled={
                                    (disableRef.current === true
                                      ? getActive === fieldConfig.name
                                        ? false
                                        : false
                                      : false) || fieldConfig.disabled
                                  }
                                  onChange={(e) => {
                                    handleSelectState(e.target.value);
                                    handleFocusChange(
                                      nextRef,
                                      nextValueRef,
                                      resetRef,
                                      timer
                                    );
                                  }}
                                >
                                  {fieldConfig.selectOptions.map(
                                    (option, index) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >{(slectedState && index === 0) ? slectedState : option.label}

                                      </option>
                                    )
                                  )}
                                </Field>
                              </div>
                            </div>
                          ))}
                          {InputFields.slice(9, 10).map((fieldConfig) => (
                            <div
                              key={fieldConfig.name}
                              onFocus={(e) => {
                                handleActive(e);
                              }}
                              className={`col-4 form-group ${getActive === fieldConfig.name
                                ? "active"
                                : null
                                } `}
                            >
                              <label htmlFor={fieldConfig.name}>
                                {fieldConfig.label}
                                {
                                  <span style={{ color: "red" }}>*</span>
                                }
                              </label>
                              <div className="formgroupIn">
                                <Field
                                  onFocus={(e) => {
                                    getActiveState.current =
                                      fieldConfig.name;
                                    handleActive(e);
                                    handleSpeakWithoutVoice(
                                      fieldConfig.name,
                                      langSelected,
                                      voiceSelected,
                                      getActiveState,
                                      fieldConfig.label
                                    );
                                  }}
                                  innerRef={fieldConfig.innerRef}
                                  as="select"
                                  className="form-control"
                                  id={fieldConfig.name}
                                  name={fieldConfig.name}
                                  value={fieldConfig.value}
                                  disabled={
                                    (disableRef.current === true
                                      ? getActive === fieldConfig.name
                                        ? false
                                        : false
                                      : false) || fieldConfig.disabled
                                  }

                                  onChange={(e) => {
                                    setDistrict(e.target.value);
                                    handleFocusChange(
                                      nextRef,
                                      nextValueRef,
                                      resetRef,
                                      timer
                                    );
                                  }}
                                >
                                  <option value={""}>
                                    {
                                      slectedDistrict ? slectedDistrict : "Select District"
                                    }

                                  </option>
                                  {filterDistrict.map((list, i) => (
                                    <option value={list.district_name}>
                                      {list.district_name}
                                    </option>
                                  ))}
                                </Field>
                              </div>
                            </div>
                          ))}
                          {InputFields.slice(10, 11).map((fieldConfig) =>
                            renderInputFields(fieldConfig, setFieldValue)
                          )}
                        </Row>
                        <Row>
                          <Col md="12">

                            <FormGroup>
                              <button
                                className="btn btn-primary"
                                type="submit" disabled={isSubmitting}
                                onClick={(e) => handleSubmit(e)}
                              >
                                {" "}
                                {translate("Submit")}{" "}
                              </button>
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Form>
        )}
      </Formik>
    </>

  );
}
export default CreateTheme;

